import moment from "moment/moment";

export default function (
  orderListData,
  orderAmountField,
  orderCountField,
  minCol = 7
) {
  const orderList = orderListData || [];
  const labels = [];
  const datasets = [
    {
      label: "Order Amount",
      fill: true,
      backgroundColor: "#7072ED",
      borderRadius: 7,
      yAxisID: "y",
      data: [],
    },
  ];
  let lastKnownTime = moment().format("D MMM");
  if (orderList && orderList.length > 0) {
    orderList.map((x) => {
      if (x.date) {
        labels.push(`${moment(x.date).format("D MMM")}`);
      } else {
        labels.push(
          `${x.day} ${moment()
            .month(x.month - 1)
            .format("MMM")}`
        );
      }

      lastKnownTime = `${x.day} ${moment()
        .month(x.month - 1)
        .format("MMM")}`;
      datasets[0].data.push(+parseFloat(x[orderAmountField]).toFixed(2));
    });
  }
  if (datasets[0].data.length < minCol) {
    if (labels.length) {
      lastKnownTime = moment(`${labels[labels.length - 1]}`, "D MMM");
    } else {
      lastKnownTime = moment(lastKnownTime, "D MMM");
    }
    Array(minCol - datasets[0].data.length)
      .fill(0)
      .map((_, i) => {
        labels.unshift(lastKnownTime.add(-1, "days").format("D MMM"));
        datasets[0].data.unshift(0.0);
      });
  }
  return {
    labels,
    datasets,
  };
}
